<template>
  <el-container class="print-template">
    <div class="test-box" :style="showTest?'width: 900px;':'width: 80px;overflow: unset;'" v-if="false">
      <div style="text-align: right;">
        <el-button type="primary" plain @click="onTest">测 试</el-button>
      </div>
      <div v-show="showTest" style="margin-top: 5px;padding-top: 5px;border-top: 1px solid #dedede;font-size: 13px;">
        <div>
          <span style="margin-left: 10px;">所选元素: {{ dragConfig.dragEl?dragConfig.dragEl.innerText:"" }}</span>
          <span style="margin-left: 10px;">mouseX: {{ dragConfig.mouse.x }}，mouseY: {{ dragConfig.mouse.y }}</span>
          <span style="margin-left: 10px;">zoomConfig: {{ zoomConfig }}</span>
          <span style="margin-left: 10px;">test: {{ tableConfig.sourceWidth }}</span>
        </div>
        <div style="margin-top: 10px;">
          <div v-for="(i,k) in dragConfig.dragDoms" :key="k">{{i}}</div>
        </div>
      </div>
    </div>
    <el-aside width="200px" class="aside left-aside">
      <div class="title">
        <span>打印模板</span>
        <div style="display: flex;">
          <div>
            <i style="color: #67C23A;" @click="onBtnFunc('add')" class="el-icon-circle-plus-outline"></i>
          </div>
          <div :class="{'btn-disable':data.TemplateId==0}">
            <i style="color: #409EFF;" @click="onBtnFunc('edit')" class="el-icon-edit-outline"></i>
            <i style="color: #F56C6C;" @click="onBtnFunc('del')" class="el-icon-delete"></i>
          </div>
        </div>
      </div>
      <template v-for="(i,k) in list">
        <div :key="k" class="item" :class="{'item-active':i.TemplateId==data.TemplateId}" @click="onSelect(i)">
          <i v-if="i.IsDefault" class="el-icon-star-on"></i>
          <span>{{i.TemplateName}}</span>
        </div>
      </template>
    </el-aside>
    <el-container>
      <el-header class="header" style="height: 150px;">
        <el-tabs v-model="tabName">
          <el-tab-pane label="常规操作" name="tab1">
            <div class="font-tools" :class="{'tools-disable': fontConfig.disabled}">
              <template v-if="fontConfig.showType">
                <el-select v-model="fontConfig.type" @change="onFontChange('type')" style="width: 80px;">
                  <el-option label="标签" value="label"></el-option>
                  <el-option label="值" value="value"></el-option>
                </el-select>
                <div style="width: 3px;"></div>
              </template>
              <el-select :disabled="fontConfig.disabled" v-model="fontConfig.size" @change="onFontChange('size')" style="width: 75px;">
                <template v-for="(i,k) in fontSizes">
                  <el-option :key="k" :label="i" :value="i"></el-option>
                </template>
              </el-select>
              <!-- <div class="font-btn" style="padding-right: 5px;" @click="onFontChange('plus')">
                <span>A</span>
                <div class="icon">+</div>
              </div>
              <div class="font-btn" style="padding-right: 5px;" @click="onFontChange('minus')">
                <span>A</span>
                <div class="icon" style="font-size: 17px;top: -4px;right: 5px;">-</div>
              </div> -->
              <div class="font-btn" style="font-weight: bold;" @click="onFontChange('bold')">B</div>
              <div class="font-btn" @click="onFontChange('italic')">
                <svg-icon style="width: 14px;" iconClass="italic"></svg-icon>
              </div>
              <div class="font-btn" @click="onFontChange('underline')">
                <svg-icon iconClass="underline"></svg-icon>
              </div>
              <div class="font-btn" @click="onFontChange('strikethrough')">
                <svg-icon style="width: 15px;" iconClass="strikethrough"></svg-icon>
              </div>
              <div class="font-btn" @click="onFontChange('left')">
                <svg-icon style="width: 14px;" iconClass="textalignleft"></svg-icon>
              </div>
              <div class="font-btn" @click="onFontChange('center')">
                <svg-icon style="width: 14px;" iconClass="textaligncenter"></svg-icon>
              </div>
              <div class="font-btn" @click="onFontChange('right')">
                <svg-icon style="width: 14px;" iconClass="textalignright"></svg-icon>
              </div>
              <div class="font-btn" @click="onFontChange('top')">
                <svg-icon style="width: 14px;" iconClass="textaligntop"></svg-icon>
              </div>
              <div class="font-btn" @click="onFontChange('vertical')">
                <svg-icon style="width: 14px;" iconClass="textalignvertical"></svg-icon>
              </div>
              <div class="font-btn" @click="onFontChange('bottom')">
                <svg-icon style="width: 14px;" iconClass="textalignbottom"></svg-icon>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="表格操作" name="tab2">
            <el-form :inline="true" class="table-tools" :class="{'tools-disable': tableConfig.disabled}">
              <div class="tools-item">
                <el-form-item label="明细行数" style="margin: 0px;">
                  <el-input v-int v-model="tableConfig.rows" @change="setTableRows" style="width: 193px;"></el-input>
                </el-form-item>
                <el-form-item label="显示合计" style="margin: 0px;">
                  <el-select v-model="tableConfig.showTotal" @change="setTableTotal" :disabled="tableConfig.disabled">
                    <el-option label="取消合计" :value="0"></el-option>
                    <el-option label="显示页小计" :value="1"></el-option>
                    <el-option label="显示总合计" :value="2"></el-option>
                    <el-option label="显示页小计&总合计" :value="3"></el-option>
                  </el-select>
                </el-form-item>
              </div>
            </el-form>
          </el-tab-pane>
          <el-tab-pane label="纸张设置" name="tab3">
            <el-form :inline="true" class="paper-tools">
              <div class="tools-item">
                <el-form-item label="纸张大小" style="margin: 0px;">
                  <el-select :disabled="data.TemplateId==0" v-model="printConfig.paper" @change="setPaperSize" placeholder="请选择">
                    <el-option v-for="(i,k) in paperSize" :key="k" :label="i.label" :value="i.label"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="纸张方向" style="margin: 0px;">
                  <el-select :disabled="data.TemplateId==0" v-model="printConfig.direction" @change="setPaperSize" placeholder="请选择">
                    <el-option label="纵向" :value="0"></el-option>
                    <el-option label="横向" :value="1"></el-option>
                  </el-select>
                </el-form-item>
              </div>
              <div class="tools-item" v-show="printConfig.paper=='自定义'">
                <el-form-item label="纸张宽度" style="margin: 0px;">
                  <el-input v-int v-model="printConfig.customWidth" @change="setCustomPaper('Width')" style="width: 140px;">
                    <template slot="append">mm</template>
                  </el-input>
                </el-form-item>
                <el-form-item label="纸张高度" style="margin: 0px;">
                  <el-input v-int v-model="printConfig.customHeight" @change="setCustomPaper('Height')" style="width: 140px;">
                    <template slot="append">mm</template>
                  </el-input>
                </el-form-item>
              </div>
              <div class="tools-item" :class="{'tools-disable': data.TemplateId==0}">
                <el-form-item label="上下边距" style="margin: 0px;">
                  <el-input v-int v-model="printConfig.paddingTop" @change="setPadding('Top')" style="width: 110px;">
                    <template slot="append">px</template>
                  </el-input>
                  <el-input v-int v-model="printConfig.paddingBottom" @change="setPadding('Bottom')" style="width: 110px;margin-left: 5px;">
                    <template slot="append">px</template>
                  </el-input>
                </el-form-item>
                <el-form-item label="左右边距" style="margin: 0px;">
                  <el-input v-int v-model="printConfig.paddingLeft" @change="setPadding('Left')" style="width: 110px;">
                    <template slot="append">px</template>
                  </el-input>
                  <el-input v-int v-model="printConfig.paddingRight" @change="setPadding('Right')" style="width: 110px;margin-left: 5px;">
                    <template slot="append">px</template>
                  </el-input>
                </el-form-item>
              </div>
            </el-form>
          </el-tab-pane>
        </el-tabs>
        <div style="position: absolute;top: 17px;right: 20px;">
          <el-button type="info" plain @click="onSetDefault" :disabled="data.TemplateId==0||data.IsDefault">设为默认</el-button>
          <el-button type="primary" plain @click="onSaveAs" :disabled="data.TemplateId==0">另存为</el-button>
          <el-button type="primary" plain @click="onSave" :disabled="data.TemplateId==0">保 存</el-button>
          <!-- <el-button type="primary" plain @click="onSet">设 置</el-button> -->
        </div>
      </el-header>
      <el-main id="main" class="main">
        <el-upload action="#" style="display: none;" :show-file-list="false" :http-request="onImgRequest">
          <el-button id="img_upload" type="primary">选取文件</el-button>
        </el-upload>
        <div id="printbox">
          <div id="paper" class="paper" style="border: 1px dashed #dedede;"></div>
        </div>
        <!-- <div id="paper" class="paper"></div> -->
        <div id="zoom" class="zoom">
          <!-- <div class="zoom-item left-top"></div> -->
          <div class="zoom-item top" @mousedown="setZoom('top')"></div>
          <!-- <div class="zoom-item right-top"></div> -->
          <div class="zoom-item left" @mousedown="setZoom('left')"></div>
          <div class="zoom-item right" @mousedown="setZoom('right')"></div>
          <!-- <div class="zoom-item left-bottom"></div> -->
          <div class="zoom-item bottom" @mousedown="setZoom('bottom')"></div>
          <!-- <div class="zoom-item right-bottom"></div> -->
        </div>
        <div id="x1_line" class="equality_line" style="display: none;width: 1px;"></div>
        <div id="x2_line" class="equality_line" style="display: none;width: 1px;"></div>
        <div id="x3_line" class="equality_line" style="display: none;width: 1px;"></div>
        <div id="y1_line" class="equality_line" style="display: none;height: 1px;"></div>
        <div id="y2_line" class="equality_line" style="display: none;height: 1px;"></div>
        <div id="y3_line" class="equality_line" style="display: none;height: 1px;"></div>
        <div id="contextmenu" v-show="contextMenu.show">
          <template v-if="contextMenu.isPaper">
            <div class="menu_item" @click="onInsertText">插入文本</div>
            <div class="menu_item" @click="onInsertTable">插入表格</div>
            <div class="menu_item" @click="onInsertImg">插入图片</div>
          </template>
          <template v-else-if="contextMenu.isTable">
            <template v-if="contextMenu.isTableTotal">
              <div class="menu_item" @click="setTotalField(true)">设置合计</div>
              <div class="menu_item" @click="setTotalField(false)">清除合计</div>
            </template>
            <div v-else class="menu_item" @click="setTbSn">设置序号</div>
            <div class="menu_item" @click="openDataType">数据类型</div>
            <div class="menu_item" @click="onInsertCol('left')">左侧插入列</div>
            <div class="menu_item" @click="onInsertCol('right')">右侧插入列</div>
            <div class="menu_item" @click="onDelCol">删除列</div>
            <div class="menu_item" @click="onDelItem">删除表格</div>
          </template>
          <template v-else>
            <template v-if="contextMenu.isItem">
              <div class="menu_item" @click="openDataType">数据类型</div>
            </template>
            <div class="menu_item" @click="onDelItem">删除元素</div>
          </template>
        </div>
      </el-main>
    </el-container>
    <el-aside width="240px" class="aside right-aside">
      <el-input placeholder="输入关键字进行过滤" v-model="right.filterText">
        <el-button slot="append" icon="el-icon-search" @click="rightTreeSearch"></el-button>
      </el-input>
      <div style="height: 10px;"></div>
      <el-tree ref="rightTree" :data="right.fields" :props="treeProps" :filter-node-method="rigthTreeFilter" default-expand-all>
        <div class="tree-node" slot-scope="{node, data}" @dblclick="rightTreeAdd(node, data)">
          <span>{{ node.label }}</span>
        </div>
      </el-tree>
    </el-aside>
    <el-dialog title="插入表格" :visible.sync="tableConfig.showSelect" width="450px">
      <el-form :inline="true">
        <el-form-item label="明细">
          <el-select v-model="tableConfig.select" placeholder="请选择明细">
            <template v-for="(i,k) in tableConfig.list">
              <el-option :key="k" :label="i.label" :value="i.value"></el-option>
            </template>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="tableConfig.showSelect = false">取 消</el-button>
        <el-button type="primary" @click="onSelectTable">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="数据类型" :visible.sync="dataConfig.show" width="450px" @closed="onCloseDataType">
      <el-form :inline="true">
        <el-form-item label="数据类型">
          <el-select v-model="dataConfig.dataType" placeholder="请选择">
            <el-option label="文本" value="string"></el-option>
            <el-option label="时间" value="datetime"></el-option>
            <el-option label="条形码" value="barcode"></el-option>
            <el-option label="二维码" value="qrcode"></el-option>
            <el-option label="数值" value="numerical"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="数据格式" v-if="dataConfig.dataType=='datetime'">
          <!-- <el-input v-model="dataConfig.format" placeholder="请输入"></el-input> -->
          <el-select v-model="dataConfig.format" placeholder="请选择">
            <el-option label="0001-01-01" value="YYYY-MM-DD"></el-option>
            <el-option label="0001/01/01" value="YYYY/MM/DD"></el-option>
            <el-option label="0001年01月01日" value="YYYY年MM月DD日"></el-option>
            <el-option label="0001-01-01 01:01:01" value="YYYY-MM-DD hh:mm:ss"></el-option>
            <el-option label="0001/01/01 01:01:01" value="YYYY/MM/DD hh:mm:ss"></el-option>
            <el-option label="0001年01月01日 01:01:01" value="YYYY年MM月DD日 hh:mm:ss"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="数据格式" v-if="dataConfig.dataType=='numerical'">
          <!-- <el-input v-model="dataConfig.format" placeholder="请输入"></el-input> -->
          <el-select v-model="dataConfig.format" placeholder="请选择">
            <el-option label="金额" value="Amount"></el-option>
            <el-option label="大写金额" value="CapitalAmount"></el-option>
            <el-option label="数量" value="Quantity"></el-option>
            <el-option label="单价" value="Price"></el-option>
            <el-option label="换算率" value="Iinvexchrate"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dataConfig.show = false">取 消</el-button>
        <el-button type="primary" @click="onSetDataType">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog :title="isEdit?'修改模板名称':'添加新模板'" :visible.sync="showNew" width="450px" @closed="onCloseNew">
      <el-form :inline="true">
        <el-form-item label="模板名称">
          <el-input v-model="editData.TemplateName" placeholder="请输入"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showNew=false">取 消</el-button>
        <el-button type="primary" @click="onSaveNew">保 存</el-button>
      </div>
    </el-dialog>
    <el-dialog title="另存为新模板" :visible.sync="showNewAs" width="450px" @closed="onCloseNew">
      <el-form :inline="true">
        <el-form-item label="模板名称">
          <el-input v-model="editData.TemplateName" placeholder="请输入"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showNewAs=false">取 消</el-button>
        <el-button type="primary" @click="onSaveNewAs">保 存</el-button>
      </div>
    </el-dialog>
  </el-container>
</template>
<script>
export default {
  data() {
    return {
      showTest: false,
      api: require("@/api/sy/printTemplate").default,
      field_api: require("@/api/sy/printFields").default,
      list: [],
      data: {
        TemplateId: 0,
        TemplateName: "",
        DocType: "",
        HtmlString: "",
        HtmlPrintString: "",
        DomJsonData: "",
        PaperJsonData: "",
        IsDefault: false,
      },
      showNew: false,
      showNewAs: false,
      isEdit: false,
      editData: {
        TemplateId: 0,
        TemplateName: "",
      },
      isChange: false,
      tabName: "tab1",
      treeProps: {
        children: 'children',
        label: 'label'
      },
      right: {
        filterText: "",
        fields: [{
          label: '页码',
          children: []
        }, {
          label: '表头表尾',
          children: []
        }, {
          label: '明细表格',
          children: []
        }],
      },
      fontSizes: [],
      fontConfig: {
        disabled: true, //工具栏是否可以点击
        showType: false,
        type: "label",
        size: "12px", //字体大小
      },
      paperSize: [
        { label: "A4", value: { width: '210mm', height: '297mm' } },
        { label: "自定义", value: { width: '', height: '' } }
      ],
      printConfig: {
        direction: 1, //0：纵向，1：横向
        paper: "A4",
        paddingTop: "",
        paddingRight: "",
        paddingBottom: "",
        paddingLeft: "",
        customWidth: "",
        customHeight: "",
      },
      dragConfig: {
        isdragging: false, //是否拖拽
        dragEl: null, //拖拽的元素
        mouse: { x: 0, y: 0 }, //鼠标位置
        dragOutable: false, //是否可以拖出纸张范围
        dragDoms: [], //可拖拽的元素数组
      },
      fieldConfig: {
        labelWidthChange: false,
        startX: 0,
        sourceWidth: 0, //原始宽度
      },
      zoomConfig: {
        direction: null, //缩放方向
        startY: 0, //开始位置
        startX: 0, //开始位置
      },
      dataConfig: {
        show: false,
        dataType: "string",
        format: "",
      },
      contextMenu: {
        show: false,
        isPaper: false,
        isItem: false,
        isText: false,
        isImg: false,
        isTable: false,
        isTableTotal: false,
      },
      tableConfig: {
        showSelect: false, //弹窗明细表格
        select: null, //选择的明细
        list: [], //表格列表
        thWidthChange: false, //是否修改列宽
        selectTh: null, //要更改宽度的列
        selectTd: null, //要更改字段的列
        selectIndex: 0,
        startX: 0, //起始值
        sourceWidth: 0, //原始宽度
        disabled: true, //工具栏是否可以点击
        rows: 1,
        showTotal: 0, //0：取消，1：显示
      },
      dragItems: ["field-item", "text-item", "img-item"],
      defaultDom: {
        domId: "",
        x: 0,
        y: 0,
        width: 0,
        height: 0,
        tableName: "",
        dataType: "string",
        format: "",
        rows: 1,
        columns: [],
      },
      test: null
    };
  },
  watch: {
    // 'right.filterText': {
    //   handler(newValue, oldValue) { }
    // }
  },
  mounted() {
    var params = this.$route.params;
    // console.log('params', this.$route.params);
    if (params.type) this.data.DocType = params.type;

    for (let i = 12; i <= 72; i += 2) {
      this.fontSizes.push(i + "px");
    }
    var field0 = this.right.fields.find(x => x.label == "页码");
    field0.children.push({ label: "共X页", value: "PageTotal" });
    field0.children.push({ label: "第X页", value: "PageIndex" });

    var field1 = this.right.fields.find(x => x.label == "表头表尾");
    var field2 = this.right.fields.find(x => x.label == "明细表格");

    this.field_api.info({ DocType: this.data.DocType }).then(res => {
      if (res.Code == 0) {
        var data = res.Data;
        var list1 = data.Fields.filter(x => x.FieldDescribe);
        list1.forEach(x => {
          field1.children.push({ label: x.FieldDescribe, value: x.FieldName });
        })
        this.tableConfig.list = [];
        data.Tables.forEach(x => {
          var children2 = [];
          var list2 = x.Fields.filter(x => x.FieldDescribe);
          list2.forEach(e => {
            children2.push({ label: e.FieldDescribe, value: e.FieldName });
          })
          field2.children.push({ label: x.TableDescribe, value: x.TableName, children: children2 });
          this.tableConfig.list.push({ label: x.TableDescribe, value: x.TableName });
        })
        if (this.tableConfig.list.length > 0) this.tableConfig.select = this.tableConfig.list[0].value;
      }
    })
    this.setPaperSize(true);
    window.addEventListener("mousemove", this.onMouseMove);
    window.addEventListener("mouseup", this.onMouseUp);
    window.addEventListener("contextmenu", this.onContextMenu);
    this.onGetList();
    // this.onSet();
  },
  methods: {
    onTest() {
      console.log("data", this.list);
      this.showTest = !this.showTest;
    },
    onSelect(data) {
      // console.log("isChange", this.isChange);
      if (this.isChange) {
        this.$confirm('模板已修改，要放弃修改吗?', '提示', {
          confirmButtonText: '放弃',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          // console.log("确定")
          this.onSelectFunc(data);
          this.isChange = false;
        }).catch(() => {
          // console.log("取消");
        });
      } else {
        this.onSelectFunc(data);
      }
    },
    onSelectFunc(data) {
      this.onInit();
      this.data.TemplateId = data.TemplateId;
      this.data.TemplateName = data.TemplateName;
      this.data.DocType = data.DocType;
      this.data.HtmlString = data.HtmlString;
      this.data.HtmlPrintString = data.HtmlPrintString;
      this.data.DomJsonData = data.DomJsonData;
      this.data.PaperJsonData = data.PaperJsonData;
      this.data.IsDefault = data.IsDefault;
      this.onSet();
    },
    onSetDefault() {
      var data = { TemplateId: this.data.TemplateId, DocType: this.data.DocType, IsDefault: true };
      this.api.setDefault(data).then(res => {
        if (res.Code == 0) {
          this.$message.success(res.Msg);
          this.data.IsDefault = true;
          this.onGetList();
        } else {
          this.$message.error(res.Msg);
        }
      })
    },
    onSave() {
      var main = document.getElementById("main");
      var save_el = document.createElement("div");
      save_el.innerHTML = main.innerHTML;

      //将缩放工具移出纸张
      let zoom = save_el.querySelector("#zoom");
      zoom.remove();
      //将参考线移出纸张
      let lines = save_el.getElementsByClassName("equality_line");
      Array(...lines).forEach(x => {
        x.remove();
      })
      let active_thtd = save_el.querySelectorAll(".active-td,.active-th");
      Array(...active_thtd).forEach(x => x.className = "");

      var ele_paper = save_el.querySelector("#paper");

      this.data.HtmlString = ele_paper.innerHTML;
      this.data.HtmlPrintString = ele_paper.innerHTML;
      this.data.DomJsonData = JSON.stringify(this.dragConfig.dragDoms);
      this.data.PaperJsonData = JSON.stringify(this.printConfig);

      this.api.save(this.data).then(res => {
        // console.log("res", res);
        if (res.Code == 0) {
          this.$message.success(res.Msg);
          this.isChange = false;
          this.onGetList();
        } else {
          this.$message.error(res.Msg);
        }
      })
    },
    onSet() {
      // console.log("onSet", this.data)
      this.dragConfig.dragDoms = JSON.parse(this.data.DomJsonData);
      this.printConfig = JSON.parse(this.data.PaperJsonData);

      this.setPaperSize(true);

      var box = document.getElementById("printbox");
      ["Top", "Right", "Bottom", "Left"].forEach(x => {
        if (this.printConfig["padding" + x]) box.style["padding" + x] = this.printConfig["padding" + x] + "px";
        else box.style["padding" + x] = "";
      })

      var ele_paper = document.getElementById("paper");
      ele_paper.innerHTML = this.data.HtmlString;

      ele_paper.childNodes.forEach(x => {
        var items = [...this.dragItems, "page-item"];
        if (items.indexOf(x.className) != -1) {
          x.addEventListener("mousedown", this.onMouseDown); //元素绑定鼠标事件
          x.addEventListener("click", this.onMouseClick); //元素绑定鼠标事件
          // x.addEventListener("blur", this.onBlur); //元素绑定鼠标事件
          if (x.className != "page-item") x.addEventListener("dblclick", this.onDblClick);
          if (x.className == "field-item") {
            x.addEventListener("mousemove", (e) => {
              if (e.target.className == "field-item") {
                var label = e.target.firstElementChild;
                if (e.offsetX > (label.clientWidth - 5) && e.offsetX < label.clientWidth) {
                  e.target.style.cursor = "e-resize";
                } else {
                  e.target.style.cursor = "";
                }
              }
            })
          }
        }
        if (x.className == "table-item") {
          // console.log('table', [x]);
          var rank = x.querySelector("i");
          rank.addEventListener("mousedown", this.onMouseDown); //元素绑定鼠标事件

          x.addEventListener("mousedown", this.onMouseDown); //元素绑定鼠标事件
          x.addEventListener("click", this.onMouseClick); //元素绑定鼠标事件
          x.addEventListener("dblclick", this.onDblClick);
          x.addEventListener("mouseenter", (e) => {
            rank.style.display = "block";
          })
          x.addEventListener("mouseleave", (e) => {
            rank.style.display = "none";
          })
          x.addEventListener("mousemove", (e) => {
            if (e.target.localName == "th") {
              // if (e.target.previousElementSibling == null) return;
              if (e.target.nextElementSibling == null) return;
              var width = e.target.clientWidth;
              // console.log('mousemove', e.offsetX);
              if ((e.offsetX > (width - 5))) {
                e.target.style.cursor = "e-resize";
              } else {
                e.target.style.cursor = "";
              }
            }
          })
        }
      })
      this.setTools();
    },
    onGetList() {
      return new Promise((resolve, reject) => {
        this.api.list({ DocType: this.data.DocType }).then(res => {
          if (res.Code == 0) this.list = res.Data;
          // console.log('getlist', this.list)
          resolve(res)
        })
      })
    },
    onInit(reset = false) {
      this.fontConfig.disabled = true;
      this.fontConfig.showType = false;
      this.fontConfig.size = "12px";
      this.tableConfig.disabled = true;
      this.tableConfig.rows = 1;
      this.tableConfig.showTotal = 0;

      var main = document.getElementById("main");
      //将缩放工具移出纸张
      let zoom = document.getElementById("zoom");
      main.appendChild(zoom);
      //将参考线移出纸张
      let lines = document.getElementsByClassName("equality_line");
      Array(...lines).forEach(x => {
        main.appendChild(x);
      })
      if (reset) {
        var ele_paper = document.getElementById("paper");
        ele_paper.innerHTML = "";
      }
    },
    setTools() {
      var ele_paper = document.getElementById("paper");
      //将缩放工具移到纸张上
      let zoom = document.getElementById("zoom");
      ele_paper.appendChild(zoom);

      //将参考线移到纸张上
      let lines = document.getElementsByClassName("equality_line");
      Array(...lines).forEach(x => {
        ele_paper.appendChild(x);
      })
    },
    onBtnFunc(type) {
      if (type == "add") {
        this.showNew = true;
      }
      if (type == "edit") {
        this.editData.TemplateName = this.data.TemplateName;
        this.isEdit = true;
        this.showNew = true;
      }
      if (type == "del") {
        if (this.data.IsDefault) {
          this.$message.warning("设为默认的模板不能删除");
          return;
        }
        this.$confirm('确认删除模板?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.api.delete({ Id: this.data.TemplateId }).then(res => {
            if (res.Code == 0) {
              this.$message.success(res.Msg);
              this.onReset();
              this.onGetList();
            } else {
              this.$message.error(res.Msg);
            }
          })
        }).catch(() => { });
      }
    },
    onSaveNew() {
      if (!this.isEdit) {
        if (!this.editData.TemplateName) { this.$message.warning("模板名称不能为空"); return; }
        var initdata = this.$options.data();
        var data = {
          TemplateId: 0,
          TemplateName: this.editData.TemplateName,
          DocType: this.data.DocType,
          HtmlString: "",
          HtmlPrintString: "",
          DomJsonData: JSON.stringify([]),
          PaperJsonData: JSON.stringify(initdata.printConfig),
          IsDefault: false,
        }
        this.api.save(data).then(res => {
          if (res.Code == 0) {
            this.showNew = false;
            this.$message.success(res.Msg);
            this.onGetList().then(res2 => {
              var template = this.list.find(x => x.TemplateId == res.Data);
              this.onSelect(template);
            });
          } else {
            this.$message.error(res.Msg);
          }
        })
      } else {
        var data = { TemplateId: this.data.TemplateId, TemplateName: this.editData.TemplateName }
        this.api.changeName(data).then(res => {
          if (res.Code == 0) {
            this.$message.success(res.Msg);
            var template = this.list.find(x => x.TemplateId == this.data.TemplateId);
            this.data.TemplateName = template.TemplateName = this.editData.TemplateName;
            this.showNew = false;
          } else {
            this.$message.error(res.Msg);
          }
        })
      }
    },
    onSaveAs() {
      this.showNewAs = true;
    },
    onSaveNewAs() {
      console.log("另存为");
      if (!this.editData.TemplateName) { this.$message.warning("模板名称不能为空"); return; }

      var main = document.getElementById("main");
      var save_el = document.createElement("div");
      save_el.innerHTML = main.innerHTML;

      //将缩放工具移出纸张
      let zoom = save_el.querySelector("#zoom");
      zoom.remove();
      //将参考线移出纸张
      let lines = save_el.getElementsByClassName("equality_line");
      Array(...lines).forEach(x => {
        x.remove();
      })
      let active_thtd = save_el.querySelectorAll(".active-td,.active-th");
      Array(...active_thtd).forEach(x => x.className = "");

      var ele_paper = save_el.querySelector("#paper");

      var data = {
        TemplateId: 0,
        TemplateName: this.editData.TemplateName,
        DocType: this.data.DocType,
        HtmlString: ele_paper.innerHTML,
        HtmlPrintString: ele_paper.innerHTML,
        DomJsonData: JSON.stringify(this.dragConfig.dragDoms),
        PaperJsonData: JSON.stringify(this.printConfig),
        IsDefault: false,
      }
      this.api.save(data).then(res => {
        if (res.Code == 0) {
          this.showNewAs = false;
          this.$message.success(res.Msg);
          this.onGetList().then(res2 => {
            var template = this.list.find(x => x.TemplateId == res.Data);
            this.isChange = false;
            this.onSelect(template);
          });
        } else {
          this.$message.error(res.Msg);
        }
      })
    },
    onCloseNew() {
      // console.log("closed");
      this.editData.TemplateId = 0;
      this.editData.TemplateName = "";
      this.isEdit = false;
    },
    onReset() {
      var initdata = this.$options.data();
      Object.assign(this.data, initdata.data);
      Object.assign(this.printConfig, initdata.printConfig);
      Object.assign(this.dragConfig, initdata.dragConfig);
      Object.assign(this.fontConfig, initdata.fontConfig);
      this.onInit(true);
    },
    setPaperSize(init = false) {
      if (init != true) this.isChange = true;
      var paper = this.paperSize.find(x => x.label == this.printConfig.paper);
      var box = document.getElementById("printbox");
      if (paper.label != "自定义") {
        var width = paper.value.width;
        var height = paper.value.height;
        if (this.printConfig.direction == 1) {
          width = paper.value.height;
          height = paper.value.width;
        }
        box.style.width = width;
        box.style.height = height;
      } else {
        if (!this.printConfig.customWidth) this.printConfig.customWidth = box.style.width.replace("mm", "");
        if (!this.printConfig.customHeight) this.printConfig.customHeight = box.style.height.replace("mm", "");

        box.style.width = this.printConfig.customWidth + "mm";
        box.style.height = this.printConfig.customHeight + "mm";
      }
    },
    setCustomPaper(type) {
      this.isChange = true;
      // console.log('setCustomPaper', type);
      var box = document.getElementById("printbox");
      if (type == "Width") box.style.width = this.printConfig.customWidth + "mm";
      if (type == "Height") box.style.height = this.printConfig.customHeight + "mm";
    },
    setPadding(type) {
      this.isChange = true;
      var box = document.getElementById("printbox");
      var value = this.printConfig["padding" + type] + "px";
      box.style["padding" + type] = value;
    },
    setTableRows() {
      this.isChange = true;
      if (this.tableConfig.rows < 1) {
        this.$message.warning("表格行数不能小于1");
        this.tableConfig.rows = 1;
      }
      var drag_el = this.dragConfig.dragEl;
      var drag_dom = this.dragConfig.dragDoms.find(x => x.domId == drag_el.dataset.identify);
      var rownumber = drag_el.querySelector(".row-number");
      drag_dom.rows = this.tableConfig.rows;
      rownumber.innerText = "x" + this.tableConfig.rows;
      rownumber.dataset.rows = this.tableConfig.rows
    },
    setTableTotal() {
      this.isChange = true;
      var drag_el = this.dragConfig.dragEl;
      var drag_dom = this.dragConfig.dragDoms.find(x => x.domId == drag_el.dataset.identify);
      drag_el.style.height = "";

      if (this.tableConfig.showTotal == 0) {
        var tfoot = drag_el.querySelector("tfoot");
        if (tfoot != null) {
          var height = drag_el.clientHeight;
          // console.log('height', height);
          // console.log("drag_dom", drag_dom);
          drag_dom.height = height - tfoot.clientHeight;
          drag_dom.columns.forEach(x => {
            x.total.dataType = "string";
            x.total.format = "";
            x.intotal.dataType = "string";
            x.intotal.format = "";
          })
          tfoot.remove();
        }
      }

      if (this.tableConfig.showTotal > 0) {
        var tfoot = drag_el.querySelector("tfoot");
        if (tfoot != null) tfoot.remove();

        var new_tfoot = document.createElement('tfoot');

        var table = drag_el.querySelector("table");
        var thead_tr = drag_el.querySelector("thead").firstElementChild;
        var length = thead_tr.children.length;
        var html_str = "";

        if (this.tableConfig.showTotal != 3) {
          if (this.tableConfig.showTotal == 1) html_str = `<tr data-total="total" style="height: 24px;"><td>页小计</td>`;
          if (this.tableConfig.showTotal == 2) html_str = `<tr data-total="intotal" style="height: 24px;"><td>总合计</td>`;

          for (let i = 1; i < length; i++) {
            html_str += `<td></td>`;
          }
          html_str += `</tr>`
        } else {
          var total_str = `<tr data-total="total" style="height: 24px;"><td>页小计</td>`;
          var intotal_str = `<tr data-total="intotal" style="height: 24px;"><td>总合计</td>`;

          for (let i = 1; i < length; i++) {
            total_str += `<td></td>`;
            intotal_str += `<td></td>`;
          }
          total_str += `</tr>`
          intotal_str += `</tr>`
          html_str = total_str + intotal_str;
        }

        new_tfoot.innerHTML = html_str;

        table.appendChild(new_tfoot);
        drag_dom.height = table.clientHeight;
      }
      drag_el.style.height = drag_dom.height + "px";
    },
    setTotalField(type) {
      var index = this.tableConfig.selectIndex;
      // console.log("index" + index, type);
      if (index == 0) return;
      var drag_el = this.dragConfig.dragEl;

      var tfoot = drag_el.querySelector("tfoot");
      var selectTd = this.tableConfig.selectTd;
      var total = selectTd.parentNode.dataset.total;
      // console.log("total", total);

      if (type) {
        var tbody = drag_el.querySelector("tbody");
        var tbody_tds = tbody.firstElementChild.children;
        var tbody_td = tbody_tds[index];
        if (tbody_td.dataset.tbfield) {
          var total_tr = tfoot.querySelector('[data-total="' + total + '"]');
          total_tr.children[index].innerText = tbody_td.dataset.tbfield;
          total_tr.children[index].setAttribute("data-field", tbody_td.dataset.tbfield); //设置元素标识
        }
      } else {
        var total_tr = tfoot.querySelector('[data-total="' + total + '"]');
        total_tr.children[index].innerText = "";
        total_tr.children[index].removeAttribute("data-field");

        var drag_dom = this.dragConfig.dragDoms.find(x => x.domId == drag_el.dataset.identify);
        var col = drag_dom.columns[index];
        col[total].dataType = "string";
        col[total].format = "";
        // console.log("drag_dom", drag_dom.columns[index]);
      }
    },
    onFontChange(type) {
      this.isChange = true;
      var drag_el = this.dragConfig.dragEl;
      // console.log([drag_el]);
      var is_table = false;
      if (drag_el.className == "table-item") {
        is_table = true;
        var th = this.tableConfig.selectTh;
        var td = this.tableConfig.selectTd;
        var e = th || td
        // console.log([e]);
        setStyle(e, this);
      } else {
        console.log("type", this.fontConfig.type);
        var item = drag_el.querySelector(".item_" + this.fontConfig.type);
        // console.log([label]);
        setStyle(item, this)
        if (drag_el.className == "field-item") {
          var value = drag_el.querySelector(".item_value");
          // console.log([value]);
          setStyle(value, this)
        }
      }

      function setStyle(e, _this) {
        if (type == "family") { }
        if (type == "size") {
          // console.log("_this", _this)
          e.style.fontSize = _this.fontConfig.size;
        }
        if (type == "bold") e.style.fontWeight = e.style.fontWeight == "bold" ? "" : "bold";
        if (type == "italic") e.style.fontStyle = e.style.fontStyle == "italic" ? "" : "italic";
        if (type == "underline") {
          var d = e.style.textDecoration;
          if (d.indexOf("underline") != -1) {
            e.style.textDecoration = d.replace("underline", "");
          } else {
            if (d.indexOf("line-through") != -1) {
              e.style.textDecoration = "line-through underline";
            } else {
              e.style.textDecoration = "underline";
            }
          }
        }
        if (type == "strikethrough") {
          var d = e.style.textDecoration;
          if (d.indexOf("line-through") != -1) {
            e.style.textDecoration = d.replace("line-through", "");
          } else {
            if (d.indexOf("underline") != -1) {
              e.style.textDecoration = "line-through underline";
            } else {
              e.style.textDecoration = "line-through";
            }
          }
        }
        if (type == "left") {
          if (is_table) e.style.textAlign = "left";
          else e.style.justifyContent = "flex-start";
        }
        if (type == "right") {
          if (is_table) e.style.textAlign = "right";
          else e.style.justifyContent = "flex-end";
        }
        if (type == "center") {
          if (is_table) e.style.textAlign = "center";
          else e.style.justifyContent = "center";
        }
        if (type == "top") {
          if (is_table) e.style.verticalAlign = "top";
          else e.style.alignItems = "flex-start";
        }
        if (type == "bottom") {
          if (is_table) e.style.verticalAlign = "bottom";
          else e.style.alignItems = "flex-end";
        }
        if (type == "vertical") {
          if (is_table) e.style.verticalAlign = "middle";
          else e.style.alignItems = "center";
        }
      }
    },
    //右边操作框相关函数
    rightTreeSearch() {
      this.$refs.rightTree.filter(this.right.filterText);
    },
    rigthTreeFilter(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    rightTreeAdd(node, data) {
      if (this.data.TemplateId == 0) return;
      if (!node.isLeaf) return;
      // console.log('node', node);
      // console.log('data', JSON.parse(JSON.stringify(data)));
      this.isChange = true;

      if (node.parent.data.label == "表头表尾") {
        this.addFieldItem(data);
      } else if (node.parent.data.label == "页码") {
        // console.log("页码");
        var ele_paper = document.getElementById("paper");
        var data_field = Math.random().toString(36).slice(2);
        var dom = document.createElement('div');
        dom.style.width = '60px';
        dom.style.height = '30px';
        dom.style.border = "1px dashed #c1c1c1";
        dom.style.position = 'absolute';
        dom.style.cursor = "default";
        // dom.style.display = "flex";
        // dom.style.alignItems = "center";
        dom.className = "page-item";
        dom.setAttribute("data-identify", "page_" + data_field); //设置元素标识
        dom.setAttribute("tabindex", 0);
        // dom.innerText = data.label;
        dom.innerHTML = `<span class="item_label" 
        data-page="${data.value}"
        style="display: flex;pointer-events: none;height: 100%;">${data.label}</span>`;
        dom.addEventListener("mousedown", this.onMouseDown); //元素绑定鼠标事件
        dom.addEventListener("click", this.onMouseClick); //元素绑定鼠标事件
        ele_paper.appendChild(dom);
        this.dragConfig.dragDoms.push({ ...this.defaultDom, domId: "page_" + data_field, width: dom.clientWidth, height: dom.clientHeight });
      } else {
        var drag_el = this.dragConfig.dragEl;
        // console.log('dragEl', [drag_el]);

        if (drag_el == null) return;
        var drag_dom = this.dragConfig.dragDoms.find(x => x.domId == drag_el.dataset.identify);
        // console.log('parent_data', JSON.parse(JSON.stringify(node.parent.data)));
        // console.log('drag_dom', JSON.parse(JSON.stringify(drag_dom)));

        if (drag_dom.tableName != node.parent.data.value) return;

        if (drag_el != null && drag_el.className == "table-item") {
          var index = this.tableConfig.selectIndex;
          var total = undefined;
          if (this.tableConfig.selectTd) {
            var parent = this.tableConfig.selectTd.parentNode;
            total = parent.dataset.total;
          }
          // console.log("total", total)
          // console.log('tableConfig', [this.tableConfig.selectTd]);

          if (total == undefined) {
            var thead_tr = drag_el.querySelector("thead").firstElementChild;
            var th = thead_tr.children[index];
            th.firstElementChild.innerText = data.label;

            var tbody_tr = drag_el.querySelector("tbody").firstElementChild;
            var td = tbody_tr.children[index];
            td.innerText = data.value;
            td.dataset.tbfield = data.value;
          } else {
            if (index != 0) {
              var tfoot = drag_el.querySelector("tfoot");
              if (tfoot) {
                var total_tr = drag_el.querySelector('[data-total="' + total + '"]');
                total_tr.children[index].innerText = data.label;
                total_tr.children[index].setAttribute("data-field", data.value); //设置元素标识
              }
            };
          }
        }
      }
    },
    addFieldItem(data) {
      var ele_paper = document.getElementById("paper");
      var data_field = Math.random().toString(36).slice(2);

      var dom = document.createElement('div');
      dom.style.width = '260px';
      dom.style.minHeight = '30px';
      dom.style.border = "1px dashed #c1c1c1";
      dom.style.position = 'absolute';
      dom.style.cursor = "default";
      dom.style.display = "flex";
      dom.className = "field-item";
      dom.setAttribute("data-identify", "field_" + data_field); //设置元素标识
      dom.setAttribute("tabindex", 0);
      var label = `<div class="item_label" style="
        pointer-events: none;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        overflow: hidden;
        width: 100px;
        border-right: 1px dashed #c1c1c1;
      ">${data.label}：</div>`
      var value = `<div class="item_value" style="
        pointer-events: none;
        display: flex;
        align-items: center;
        overflow: hidden;
        color: #898989;
        width: calc(100% - 100px);
      ">${data.value}</div>`;
      dom.innerHTML = label + value;
      dom.addEventListener("mousedown", this.onMouseDown); //元素绑定鼠标事件
      dom.addEventListener("click", this.onMouseClick); //元素绑定鼠标事件
      // dom.addEventListener("blur", this.onBlur); //元素绑定鼠标事件
      dom.addEventListener("dblclick", this.onDblClick);
      dom.addEventListener("mousemove", (e) => {
        // console.log('label', e);
        if (e.target.className == "field-item") {
          var label = e.target.firstElementChild;
          if (e.offsetX > (label.clientWidth - 5) && e.offsetX < label.clientWidth) {
            e.target.style.cursor = "e-resize";
          } else {
            e.target.style.cursor = "";
          }
        }
      })
      ele_paper.appendChild(dom);
      // console.log('dom', [dom]);
      this.dragConfig.dragDoms.push({
        ...this.defaultDom,
        domId: "field_" + data_field,
        width: dom.clientWidth,
        height: dom.clientHeight,
        tableName: data.value,
      });
    },
    //鼠标按下相关函数
    onMouseDown(e) {
      if (this.data.TemplateId == 0) return;
      if (e.button != 0) return;

      // console.log('鼠标按下', e);
      //缩放元素相关代码
      if (e.target.classList.contains("zoom-item")) {
        this.zoomConfig.startY = e.pageY;
        this.zoomConfig.startX = e.pageX;
      }
      //移动元素相关代码
      if (this.dragItems.indexOf(e.target.className) != -1) {
        this.dragConfig.dragEl = e.target;
        if (e.target.style.cursor == "e-resize") {
          this.fieldConfig.labelWidthChange = true;
          this.fieldConfig.startX = e.clientX;
          var label = e.target.firstElementChild;
          this.fieldConfig.sourceWidth = label.clientWidth;
        } else {
          this.dragConfig.mouse.x = e.pageX;
          this.dragConfig.mouse.y = e.pageY;
          this.dragConfig.isdragging = true;
        }
      }
      if (e.target.className == "page-item") {
        this.dragConfig.dragEl = e.target;
        this.dragConfig.mouse.x = e.pageX;
        this.dragConfig.mouse.y = e.pageY;
        this.dragConfig.isdragging = true;
      }
      //移动表格相关代码
      if (e.target.className == "el-icon-rank") {
        var table = e.target.parentNode;
        if (table.className == "table-item") {
          this.dragConfig.dragEl = table;
          this.dragConfig.mouse.x = e.pageX;
          this.dragConfig.mouse.y = e.pageY;
          this.dragConfig.isdragging = true;
        }
      }
      //调整表头宽度相关代码
      if (e.target.localName == "th") {
        if (e.target.style.cursor == "e-resize") {
          // console.log("onMouseDown", e);
          var table = e.target.offsetParent;
          this.dragConfig.dragEl = table.parentNode;
          this.tableConfig.thWidthChange = true;
          this.tableConfig.selectTh = e.target;
          // this.test = this.tableConfig.selectTh.innerText;
          this.tableConfig.startX = e.clientX;
          this.tableConfig.sourceWidth = this.tableConfig.selectTh.clientWidth;
        }
      }
    },
    //鼠标移动相关函数
    onMouseMove(e) {
      //移动元素/表格相关代码
      if (this.dragConfig.isdragging) {
        this.isChange = true;
        //元素拖拽
        document.body.style.userSelect = "none";
        var drag_el = this.dragConfig.dragEl;
        var drag_dom = this.dragConfig.dragDoms.find(x => x.domId == drag_el.dataset.identify);
        //新位置 - 旧位置 = 移动的值
        const moveX = e.pageX - this.dragConfig.mouse.x;
        const moveY = e.pageY - this.dragConfig.mouse.y;
        //得出元素移动后的新位置
        let newX = drag_dom.x + moveX;
        let newY = drag_dom.y + moveY;

        //domEl是否可以拖拽出父元素
        if (!this.dragConfig.dragOutable) {
          var ele_paper = document.getElementById("paper");
          //左边界最大值为0
          if (drag_dom.x < 0) newX = 0;
          //右边界最大值 纸张宽度 - 拖拽元素宽度
          var right_max = ele_paper.clientWidth - drag_el.clientWidth;
          if (drag_dom.x > right_max) newX = right_max;
          //上边界最大值为0
          if (drag_dom.y < 0) newY = 0;
          //下边界最大值 纸张高度 - 拖拽元素高度
          var bottom_max = ele_paper.clientHeight - drag_el.clientHeight;
          if (drag_dom.y > bottom_max) newY = bottom_max;
        }

        //记录鼠标位置
        this.dragConfig.mouse.x = e.pageX;
        this.dragConfig.mouse.y = e.pageY;

        //更新拖拽元素位置
        drag_dom.x = newX;
        drag_dom.y = newY;

        //移动元素
        drag_el.style.left = drag_dom.x + 'px';
        drag_el.style.top = drag_dom.y + 'px';
        this.setLine();
      }
      //缩放元素/表格相关代码
      if (this.zoomConfig.direction != null) {
        this.isChange = true;
        //元素缩放
        document.body.style.userSelect = "none";
        var drag_el = this.dragConfig.dragEl;
        var is_table = drag_el.className == "table-item";
        // console.log("target", [drag_el]);
        var drag_dom = this.dragConfig.dragDoms.find(x => x.domId == drag_el.dataset.identify);

        if (this.zoomConfig.direction == "top") {
          //新位置 - 旧位置 = 移动的值
          const moveY = e.pageY - this.zoomConfig.startY;
          //得出元素缩放后的新高度
          let newHeight = Number(drag_dom.height) + (moveY * -1);
          if (newHeight < 20) {
            newHeight = 20; //限制最小值
          } else {
            //得出元素缩放后的新位置
            let newY = Number(drag_dom.y) + moveY;
            drag_el.style.top = newY + 'px';
          }
          drag_el.style.height = newHeight + "px";
        }
        if (this.zoomConfig.direction == "bottom") {
          //新位置 - 旧位置 = 移动的值
          const moveY = e.pageY - this.zoomConfig.startY;
          //得出元素缩放后的新高度
          let newHeight = Number(drag_dom.height) + moveY;
          if (newHeight <= 20) newHeight = 20; //限制最小值
          drag_el.style.height = newHeight + "px";
        }
        if (this.zoomConfig.direction == "left") {
          //新位置 - 旧位置 = 移动的值
          const moveX = e.pageX - this.zoomConfig.startX;
          if (!is_table) {
            //得出元素缩放后的新高度
            let newWidth = Number(drag_dom.width) + (moveX * -1);
            if (newWidth < 50) {
              newWidth = 50; //限制最小值
            } else {
              //得出元素缩放后的新位置
              let newX = Number(drag_dom.x) + moveX;
              drag_el.style.left = newX + 'px';
            }
            drag_el.style.width = newWidth + "px";
          } else {
            var thead = drag_el.querySelector("thead");
            var thead_tr = thead.firstElementChild;
            var first_th = thead_tr.firstElementChild;
            if (this.tableConfig.sourceWidth == 0) this.tableConfig.sourceWidth = first_th.clientWidth;
            //得出元素缩放后的新位置
            let newX = Number(drag_dom.x) + moveX;
            drag_el.style.left = newX + 'px';
            first_th.style.width = ((moveX * -1) + this.tableConfig.sourceWidth) + "px";
          }
        }
        if (this.zoomConfig.direction == "right") {
          //新位置 - 旧位置 = 移动的值
          const moveX = e.pageX - this.zoomConfig.startX;
          if (!is_table) {
            //得出元素缩放后的新高度
            let newWidth = Number(drag_dom.width) + moveX;
            if (newWidth <= 50) newWidth = 50; //限制最小值
            drag_el.style.width = newWidth + "px";
          } else {
            var thead = drag_el.querySelector("thead");
            var thead_tr = thead.firstElementChild;
            var last_th = thead_tr.lastElementChild;
            if (this.tableConfig.sourceWidth == 0) this.tableConfig.sourceWidth = last_th.clientWidth;
            last_th.style.width = (moveX + this.tableConfig.sourceWidth) + "px";
          }
        }
        // this.setLine();
      }
      //调整表头宽度相关代码
      if (this.tableConfig.thWidthChange) {
        this.isChange = true;
        document.body.style.userSelect = "none";
        var th = this.tableConfig.selectTh;
        var move = e.clientX - this.tableConfig.startX;
        // console.log("列宽", move + this.tableConfig.sourceWidth);
        th.style.width = (move + this.tableConfig.sourceWidth) + "px";
      }
      //调整标签宽度相关代码
      if (this.fieldConfig.labelWidthChange) {
        this.isChange = true;
        document.body.style.userSelect = "none";
        var drag_el = this.dragConfig.dragEl;
        var move = e.clientX - this.fieldConfig.startX;
        // console.log("drag_el", [drag_el])
        var label = drag_el.querySelector(".item_label");
        var width = move + this.fieldConfig.sourceWidth;
        label.style.width = width + "px";
        var value = drag_el.querySelector(".item_value");
        value.style.width = "calc(100% - " + width + "px)";
        // drag_el.style.width = (width + drag_el.clientWidth) + "px";
      }
    },
    //鼠标抬起相关函数
    onMouseUp(e) {
      if (this.data.TemplateId == 0) return;
      // console.log('onMouseUp', e)
      document.body.style.userSelect = "";
      this.dragConfig.isdragging = false;
      this.dragConfig.mouse.x = 0;
      this.dragConfig.mouse.y = 0;

      this.tableConfig.sourceWidth = 0;
      if (this.tableConfig.thWidthChange) {
        var drag_el = this.dragConfig.dragEl;
        // console.log('drag', [drag_el]);
        var drag_dom = this.dragConfig.dragDoms.find(x => x.domId == drag_el.dataset.identify);
        drag_dom.width = drag_el.clientWidth;
        this.tableConfig.thWidthChange = false;
        this.tableConfig.startX = 0;
      }

      this.fieldConfig.labelWidthChange = false;

      //元素缩放相关代码
      if (this.zoomConfig.direction != null) {
        var drag_el = this.dragConfig.dragEl;
        var drag_dom = this.dragConfig.dragDoms.find(x => x.domId == drag_el.dataset.identify);
        if (this.zoomConfig.direction == "top") {
          drag_dom.y = drag_dom.y - (drag_el.clientHeight - drag_dom.height);
        }
        if (this.zoomConfig.direction == "left") {
          drag_dom.x = drag_dom.x - (drag_el.clientWidth - drag_dom.width);
        }
        // drag_dom.x =  drag_el.offsetLeft;
        drag_dom.height = drag_el.clientHeight;
        drag_dom.width = drag_el.clientWidth;
        this.zoomConfig.direction = null;
      }
      this.zoomConfig.startY = 0;
      this.zoomConfig.startX = 0;

      //移除所有的参考线
      let lines = document.getElementsByClassName("equality_line");
      Array(...lines).forEach(x => {
        x.style.display = "none";
      })

      var active = document.activeElement;
      if (!active.dataset.identify && e.target.id == "paper") {
        // console.log('移到纸张上')
        var ele_paper = document.getElementById("paper");
        //点击纸张时将缩放工具移到纸张上
        let zoom = document.getElementById("zoom");
        ele_paper.appendChild(zoom);
        this.dragConfig.dragEl = null;
      }

      // console.log('drag', [this.dragConfig.dragEl]);
      if (this.dragConfig.dragEl == null) {
        this.fontConfig.disabled = true;
        this.fontConfig.showType = false;
        this.tableConfig.disabled = true;
        var page_items = document.querySelectorAll(".page-item");
        Array(...page_items).forEach(x => x.style.borderColor = "#c1c1c1");
      }
      this.contextMenu.show = false;
    },
    //参考线相关函数
    setLine() {
      if (this.dragConfig.dragDoms.length > 1) {
        //两个以上才计算参考线
        var drag_el = this.dragConfig.dragEl;
        var drag_dom = this.dragConfig.dragDoms.find(x => x.domId == drag_el.dataset.identify);

        var x1 = drag_dom.x;
        var x2 = drag_dom.x + Math.trunc(drag_el.clientWidth / 2);
        var x3 = drag_dom.x + drag_el.clientWidth;

        //左
        var x_equality1 = this.dragConfig.dragDoms.filter(d => d.x == x1);
        if (x_equality1.length > 1) {
          var sort = x_equality1.sort((max, min) => max.y - min.y);
          this.setLineDisplay("x1", "block", x1, sort);
        } else {
          this.setLineDisplay("x1", "none");
        }
        //中
        var x_equality2 = this.dragConfig.dragDoms.filter(d => (d.x + Math.trunc(d.width / 2)) == x2);
        if (x_equality2.length > 1) {
          var sort = x_equality2.sort((max, min) => max.y - min.y);
          this.setLineDisplay("x2", "block", x2, sort);
        } else {
          this.setLineDisplay("x2", "none");
        }
        //右
        var x_equality3 = this.dragConfig.dragDoms.filter(d => (d.x + d.width) == x3);
        if (x_equality3.length > 1) {
          var sort = x_equality3.sort((max, min) => max.y - min.y);
          this.setLineDisplay("x3", "block", x3, sort);
        } else {
          this.setLineDisplay("x3", "none");
        }

        var y1 = drag_dom.y;
        var y2 = drag_dom.y + Math.trunc(drag_el.clientHeight / 2);
        var y3 = drag_dom.y + drag_el.clientHeight;

        //上
        var y_equality1 = this.dragConfig.dragDoms.filter(d => d.y == y1);
        if (y_equality1.length > 1) {
          var sort = y_equality1.sort((max, min) => max.x - min.x);
          this.setLineDisplay("y1", "block", y1, sort);
        } else {
          this.setLineDisplay("y1", "none");
        }
        //中
        var y_equality2 = this.dragConfig.dragDoms.filter(d => (d.y + Math.trunc(d.height / 2)) == y2);
        if (y_equality2.length > 1) {
          var sort = y_equality2.sort((max, min) => max.x - min.x);
          this.setLineDisplay("y2", "block", y2, sort);
        } else {
          this.setLineDisplay("y2", "none");
        }
        //下
        var y_equality3 = this.dragConfig.dragDoms.filter(d => (d.y + d.height) == y3);
        if (y_equality3.length > 1) {
          var sort = y_equality3.sort((max, min) => max.x - min.x);
          this.setLineDisplay("y3", "block", y3, sort);
        } else {
          this.setLineDisplay("y3", "none");
        }
      }
    },
    setLineDisplay(t, display, value, sort) {
      var line = document.getElementById(t + "_line");
      if (display == "none") { line.style.display = "none"; return; }

      var min_point = sort[0];
      var max_point = sort[sort.length - 1];
      if (t.indexOf("x") != -1) {
        line.style.left = value + "px";
        line.style.top = min_point.y + "px";
        line.style.height = (max_point.y - min_point.y + max_point.height) + "px";
        line.style.display = "block";
      }
      if (t.indexOf("y") != -1) {
        line.style.left = min_point.x + "px";
        line.style.top = value + "px";
        line.style.width = (max_point.x - min_point.x + max_point.width) + "px";
        line.style.display = "block";
      }
    },
    //鼠标点击事件函数
    onMouseClick(e) {
      if (this.data.TemplateId == 0) return;
      // console.log('单击鼠标', e);
      this.fontConfig.disabled = true;
      this.fontConfig.showType = false;
      this.fontConfig.type = "label";
      this.tableConfig.disabled = true;

      if (e.target.className == "field-item") {
        this.fontConfig.showType = true;
      }
      //缩放元素相关代码
      if (["field-item", "text-item"].indexOf(e.target.className) != -1) {
        let zoom = document.getElementById("zoom");
        e.target.appendChild(zoom);
        this.fontConfig.disabled = false;
      }
      var page_items = document.querySelectorAll(".page-item");
      Array(...page_items).forEach(x => x.style.borderColor = "#c1c1c1");
      if (e.target.className == "page-item") {
        this.fontConfig.disabled = false;
        e.target.style.borderColor = "#409eff";
      }
      //表格操作相关代码
      if (e.target.localName == "td" || e.target.localName == "th") {
        this.fontConfig.disabled = false;
        this.tableConfig.disabled = false;

        var table = e.target.offsetParent.parentNode;
        if (table.className == "table-item") {
          this.dragConfig.dragEl = table;
          // console.log('单击鼠标');
          let zoom = document.getElementById("zoom");
          table.appendChild(zoom);

          var tfoot = table.querySelector("tfoot");
          if (tfoot == null) {
            this.tableConfig.showTotal = 0;
          } else if (tfoot.children.length > 1) {
            this.tableConfig.showTotal = 3;
          } else {
            var total = tfoot.querySelector('[data-total="total"]');
            if (total != null) this.tableConfig.showTotal = 1;
            else this.tableConfig.showTotal = 2;
          }

          var rownumber = table.querySelector(".row-number");
          this.tableConfig.rows = rownumber.dataset.rows;

          var thtds = table.querySelectorAll("th,td");
          Array(...thtds).forEach(x => x.className = "");

          this.tableConfig.selectIndex = e.target.cellIndex;
          if (e.target.localName == "th") {
            e.target.className = "active-th";
            this.tableConfig.selectTh = e.target;
            this.tableConfig.selectTd = null;
          }
          if (e.target.localName == "td") {
            e.target.className = "active-td";
            this.tableConfig.selectTh = null;
            this.tableConfig.selectTd = e.target;
          }
        }
      }
    },
    setZoom(direction) {
      if (this.data.TemplateId == 0) return;
      // console.log('setZoom');
      let zoom = document.getElementById("zoom");
      if (zoom.parentNode.id == "paper") return;
      this.zoomConfig.direction = direction;
    },
    //右键菜单相关函数
    onContextMenu(e) {
      // console.log('onContextMenu', e);
      e.preventDefault();

      if (this.data.TemplateId == 0) return;

      this.contextMenu.isPaper = false;
      this.contextMenu.isItem = false;
      this.contextMenu.isText = false;
      this.contextMenu.isImg = false;
      this.contextMenu.isTable = false;
      this.contextMenu.isTableTotal = false;

      if (e.target.id == "paper") {
        // console.log("纸张右键", e);
        var menu = document.getElementById("contextmenu");
        //21是margin的值
        menu.style.left = (e.layerX + 21) + "px";
        menu.style.top = (e.layerY + 21) + "px";
        this.contextMenu.isPaper = true;
        this.contextMenu.show = true;
      } else {
        var items = [...this.dragItems, "page-item"];
        if (items.indexOf(e.target.className) != -1) {
          this.dragConfig.dragEl = e.target;
          var drag_el = e.target;
          var drag_dom = this.dragConfig.dragDoms.find(x => x.domId == drag_el.dataset.identify);
          console.log('drag_dom', drag_dom);
          var menu = document.getElementById("contextmenu");
          //21是margin的值
          this.$nextTick(() => {
            menu.style.left = drag_dom.x + (e.layerX + 21) + "px";
            menu.style.top = drag_dom.y + (e.layerY + 21) + "px";
            this.contextMenu.isItem = e.target.className == "field-item";
            this.contextMenu.isText = e.target.className == "text-item";
            this.contextMenu.isImg = e.target.className == "img-item";
            this.contextMenu.isTable = e.target.className == "table-item";
            this.contextMenu.isTableTotal = e.target.className == "table-item";
            this.contextMenu.show = true;
          })
        }
        if (e.target.localName == "td" || e.target.localName == "th") {
          this.contextMenu.isTableTotal = e.target.parentNode.parentNode.localName == "tfoot";

          var table = e.target.offsetParent.parentNode;
          this.dragConfig.dragEl = table;
          if (e.target.localName == "td") this.tableConfig.selectTd = e.target;
          // console.log('onContextMenu', this.dragConfig.dragEl);
          var drag_dom = this.dragConfig.dragDoms.find(x => x.domId == table.dataset.identify);
          // console.log('drag_dom', drag_dom);
          var menu = document.getElementById("contextmenu");
          //21是margin的值
          menu.style.left = drag_dom.x + (e.layerX + 21) + "px";
          menu.style.top = drag_dom.y + (e.layerY + 21) + "px";
          this.contextMenu.isTable = true;
          this.contextMenu.show = true;
          this.tableConfig.selectIndex = e.target.cellIndex;
        }
      }
    },
    //插入标签
    onInsertText(e) {
      this.isChange = true;
      // console.log('onInsertText');

      var ele_paper = document.getElementById("paper");
      var text_field = Math.random().toString(36).slice(2);

      // var menu = document.getElementById("contextmenu");
      // console.log('menu', menu.style.left);

      var dom = document.createElement('div');
      dom.style.width = '200px';
      dom.style.height = '30px';
      dom.style.border = "1px dashed #c1c1c1";
      dom.style.position = 'absolute';
      dom.style.cursor = "default";
      // dom.style.left = menu.style.left;
      // dom.style.top = menu.style.top;
      dom.className = "text-item";
      dom.setAttribute("data-identify", "text_" + text_field); //设置元素标识
      dom.setAttribute("tabindex", 0);
      dom.innerHTML = `<span class="item_label" style="pointer-events: none;height: 100%;"></span>`;
      dom.addEventListener("mousedown", this.onMouseDown); //元素绑定鼠标事件
      dom.addEventListener("click", this.onMouseClick); //元素绑定鼠标事件
      // dom.addEventListener("blur", this.onBlur); //元素绑定鼠标事件
      dom.addEventListener("dblclick", this.onDblClick);
      ele_paper.appendChild(dom);
      // console.log('dom', [dom]);
      this.dragConfig.dragDoms.push({
        ...this.defaultDom,
        domId: "text_" + text_field,
        width: dom.clientWidth,
        height: dom.clientHeight,
      });
    },
    //打开插入明细的弹窗
    onInsertTable() {
      // console.log("onInsertTable");
      this.tableConfig.showSelect = true;
    },
    //添加明细表格
    onSelectTable() {
      this.isChange = true;
      // console.log("onSelectTable");

      var select_table = this.tableConfig.list.find(x => x.value == this.tableConfig.select);
      // console.log("select_table", select_table);

      if (this.dragConfig.dragDoms.some(x => x.tableName == select_table.value)) {
        this.$message.warning("所选明细表[" + select_table.label + "]已存在");
        return;
      }

      this.tableConfig.showSelect = false;

      var ele_paper = document.getElementById("paper");
      var table_field = Math.random().toString(36).slice(2);

      // var menu = document.getElementById("contextmenu");
      // console.log('menu', menu.style.left);

      var dom = document.createElement('div');
      // dom.style.width = '600px';
      dom.style.height = '48px';
      // dom.style.left = menu.style.left;
      // dom.style.top = menu.style.top;
      dom.className = "table-item";
      dom.setAttribute("data-identify", "table_" + table_field); //设置元素标识
      // dom.setAttribute("tabindex", 0);
      dom.innerHTML = `<table>
            <thead>
              <tr style="height: 24px;">
                <th style="width: 100px;"><span class="item_label" style="pointer-events: none;"></span></th>
                <th style="width: 100px;"><span class="item_label" style="pointer-events: none;"></span></th>
                <th style="width: 100px;"><span class="item_label" style="pointer-events: none;"></span></th>
                <th style="width: 100px;"><span class="item_label" style="pointer-events: none;"></span></th>
                <th style="width: 100px;"><span class="item_label" style="pointer-events: none;"></span></th>
                <th style="width: 100px;"><span class="item_label" style="pointer-events: none;"></span></th>
              </tr>
            </thead>
            <tbody>
              <tr style="height: 24px;"><td></td><td></td><td></td><td></td><td></td><td></td></tr>
            </tbody></table>`;
      var rank = document.createElement('i');
      rank.className = "el-icon-rank";
      rank.style.display = "none";
      rank.style.position = "absolute"
      rank.style.fontSize = "22px"
      rank.style.left = "-22px";
      rank.style.top = "0";
      // rank.innerHTML = `<i class=""></i>`;
      rank.addEventListener("mousedown", this.onMouseDown); //元素绑定鼠标事件
      // rank.addEventListener("click", this.onMouseClick); //元素绑定鼠标事件
      dom.appendChild(rank);

      var rownumber = document.createElement('div');
      rownumber.className = "row-number";
      rownumber.innerText = "x1";
      rownumber.setAttribute("data-rows", 1); //设置元素标识

      dom.appendChild(rownumber);

      dom.addEventListener("mousedown", this.onMouseDown); //元素绑定鼠标事件
      dom.addEventListener("click", this.onMouseClick); //元素绑定鼠标事件
      // dom.addEventListener("blur", this.onBlur); //元素绑定鼠标事件
      dom.addEventListener("dblclick", this.onDblClick);
      dom.addEventListener("mouseenter", (e) => {
        rank.style.display = "block";
      })
      dom.addEventListener("mouseleave", (e) => {
        rank.style.display = "none";
      })
      dom.addEventListener("mousemove", (e) => {
        if (e.target.localName == "th") {
          // if (e.target.previousElementSibling == null) return;
          if (e.target.nextElementSibling == null) return;
          var width = e.target.clientWidth;
          // console.log('mousemove', e.offsetX);
          if ((e.offsetX > (width - 5))) {
            e.target.style.cursor = "e-resize";
          } else {
            e.target.style.cursor = "";
          }
        }
      })
      ele_paper.appendChild(dom);
      // console.log('dom', [dom]);
      var columns = []
      for (let i = 0; i < 6; i++) {
        columns.push({
          dataType: "string", format: "",
          total: { dataType: "string", format: "" },
          intotal: { dataType: "string", format: "" }
        });
      }
      this.dragConfig.dragDoms.push({
        ...this.defaultDom,
        domId: "table_" + table_field,
        width: dom.clientWidth,
        height: dom.clientHeight,
        tableName: select_table.value,
        dataType: null,
        format: null,
        columns: columns
      });
    },
    //插入图片
    onInsertImg() {
      this.isChange = true;
      var ele_paper = document.getElementById("paper");
      var img_field = Math.random().toString(36).slice(2);

      // var menu = document.getElementById("contextmenu");
      // console.log('menu', menu.style.left);

      var dom = document.createElement('div');
      dom.style.width = '100px';
      dom.style.height = '100px';
      dom.style.border = "1px dashed #c1c1c1";
      dom.style.position = 'absolute';
      dom.style.cursor = "default";
      // dom.style.left = menu.style.left;
      // dom.style.top = menu.style.top;
      dom.className = "img-item";
      dom.setAttribute("data-identify", "img_" + img_field); //设置元素标识
      dom.setAttribute("tabindex", 0);
      var img = document.createElement('img');
      img.style.pointerEvents = "none";
      img.style.userSelect = "none";
      img.style.height = "100%";
      img.style.width = "100%";
      img.src = require("@/assets/default_img.png");
      dom.appendChild(img);
      dom.addEventListener("mousedown", this.onMouseDown); //元素绑定鼠标事件
      dom.addEventListener("click", this.onMouseClick); //元素绑定鼠标事件
      // dom.addEventListener("blur", this.onBlur); //元素绑定鼠标事件
      dom.addEventListener("dblclick", this.onDblClick);
      ele_paper.appendChild(dom);
      // console.log('dom', [dom]);
      this.dragConfig.dragDoms.push({
        ...this.defaultDom,
        domId: "img_" + img_field,
        width: dom.clientWidth,
        height: dom.clientHeight,
        dataType: null,
        format: null,
      });
    },
    async onImgRequest(data) {
      this.isChange = true;
      var drag_el = this.dragConfig.dragEl;
      // console.log("onImgRequest", data);
      var img = drag_el.firstElementChild;
      let reader = new FileReader();
      reader.readAsDataURL(data.file); //图片转base64
      reader.onload = (e) => {
        img.src = e.target.result;
      }
    },
    openDataType() {
      // console.log("数据类型");
      var drag_el = this.dragConfig.dragEl;
      var drag_dom = this.dragConfig.dragDoms.find(x => x.domId == drag_el.dataset.identify);

      if (drag_el.className == "field-item") {
        this.dataConfig.dataType = drag_dom.dataType;
        this.dataConfig.format = drag_dom.format;
      }

      if (drag_el.className == "table-item") {
        console.log("isTableTotal", this.contextMenu.isTableTotal);
        var column = drag_dom.columns[this.tableConfig.selectIndex];
        if (this.contextMenu.isTableTotal) {
          var selectTd = this.tableConfig.selectTd;
          // console.log("selectTd", [selectTd]);
          if (!selectTd.dataset.field) { this.$message.warning("请先设置合计字段"); return; }

          var total = selectTd.parentNode.dataset.total;
          // console.log("total", total);
          // console.log("column", JSON.parse(JSON.stringify(column)));
          this.dataConfig.dataType = column[total].dataType;
          this.dataConfig.format = column[total].format;
        } else {
          var tbody = drag_el.querySelector("tbody");
          var tbody_tr = tbody.firstElementChild;
          var td = tbody_tr.children[this.tableConfig.selectIndex];
          if (!td.dataset.tbfield) { this.$message.warning("请先设置明细字段"); return; }
          this.dataConfig.dataType = column.dataType;
          this.dataConfig.format = column.format;
        }
      }

      this.dataConfig.show = true;
    },
    onSetDataType() {
      if (this.dataConfig.dataType == "datetime" || this.dataConfig.dataType == "numerical") {
        if (this.dataConfig.format == "") {
          this.$message.warning("请选择数据格式");
          return;
        }
      }

      this.isChange = true;
      var drag_el = this.dragConfig.dragEl;
      // console.log("drag_el", [drag_el]);
      var drag_dom = this.dragConfig.dragDoms.find(x => x.domId == drag_el.dataset.identify);
      // console.log('drag_dom', drag_dom);
      if (drag_el.className == "field-item") {
        var value = drag_el.querySelector(".item_value");
        value.innerHTML = drag_dom.tableName;

        if (this.dataConfig.dataType == "barcode" || this.dataConfig.dataType == "qrcode") {
          value.innerHTML = drag_dom.tableName;
          var img = document.createElement('img');
          img.style.pointerEvents = "none";
          img.style.userSelect = "none";
          img.style.height = "28px";
          img.src = require("@/assets/" + this.dataConfig.dataType + ".png");
          value.insertBefore(img, value.firstChild);
        }
        drag_dom.dataType = this.dataConfig.dataType;
        drag_dom.format = this.dataConfig.format;
      }
      if (drag_el.className == "table-item") {
        // console.log("tableConfig", this.tableConfig.selectIndex);
        // console.log("isTableTotal", this.contextMenu.isTableTotal);
        var column = drag_dom.columns[this.tableConfig.selectIndex];
        if (this.contextMenu.isTableTotal) {
          var selectTd = this.tableConfig.selectTd;
          var total = selectTd.parentNode.dataset.total;
          // console.log("total", total);
          column[total].dataType = this.dataConfig.dataType;
          column[total].format = this.dataConfig.format;
          // console.log("column", JSON.parse(JSON.stringify(column)));
        } else {
          column.dataType = this.dataConfig.dataType;
          column.format = this.dataConfig.format;

          var tbody = drag_el.querySelector("tbody");
          var tbody_tr = tbody.firstElementChild;
          var td = tbody_tr.children[this.tableConfig.selectIndex];
          // if (!td.dataset.tbfield) {
          //   this.$message.warning("请先设置明细字段");
          //   return;
          // }
          td.innerHTML = td.dataset.tbfield || td.innerText;
          if (this.dataConfig.dataType == "barcode" || this.dataConfig.dataType == "qrcode") {
            var img = document.createElement('img');
            img.style.pointerEvents = "none";
            img.style.userSelect = "none";
            img.style.height = "16px";
            img.style.display = "inline-block";
            img.style.verticalAlign = "bottom";
            img.src = require("@/assets/" + this.dataConfig.dataType + ".png");
            td.insertBefore(img, td.firstChild);
          }
        }
      }
      this.dataConfig.show = false;
    },
    onCloseDataType() {
      this.dataConfig.dataType = "string";
      this.dataConfig.format = "";
    },
    //设置表格序号
    setTbSn() {
      this.isChange = true;
      var index = this.tableConfig.selectIndex;
      var drag_el = this.dragConfig.dragEl;
      var drag_dom = this.dragConfig.dragDoms.find(x => x.domId == drag_el.dataset.identify);
      // console.log("drag_el", drag_el);
      var tbody = drag_el.querySelector("tbody");
      var tbody_tr = tbody.firstElementChild;

      var td = tbody_tr.children[index];
      td.innerText = "Sn";
      td.dataset.tbfield = "Sn";
    },
    //删除元素
    onDelItem() {
      this.isChange = true;
      // console.log('onDelItem', [this.dragConfig.dragEl]);
      var items = ["field-item", "text-item", "table-item", "img-item", "page-item"];
      var drag_el = this.dragConfig.dragEl;
      if (items.indexOf(drag_el.className) != -1) {
        var drag_dom_index = this.dragConfig.dragDoms.findIndex(x => x.domId == drag_el.dataset.identify);
        this.dragConfig.dragDoms.splice(drag_dom_index, 1);

        var ele_paper = document.getElementById("paper");
        let zoom = document.getElementById("zoom");
        ele_paper.appendChild(zoom);

        drag_el.remove(); //删除元素

        var items = document.querySelectorAll('[data-identify]');
        items = Array(...items).filter(x => x.className != "page-item")
        console.log("items", items)
        var length = items.length;
        if (length == 0) return;
        this.dragConfig.dragEl = items[length - 1];
        this.dragConfig.dragEl.appendChild(zoom);
      }
    },
    //插入表格列
    onInsertCol(type) {
      this.isChange = true;
      // console.log("onInsertCol", type, this.tableConfig.selectIndex);
      var index = this.tableConfig.selectIndex;
      var drag_el = this.dragConfig.dragEl;
      var drag_dom = this.dragConfig.dragDoms.find(x => x.domId == drag_el.dataset.identify);
      // console.log("drag_el", drag_el);

      var thead = drag_el.querySelector("thead");
      var thead_tr = thead.firstElementChild;
      // console.log("thead_tr", [thead_tr]);
      var th = document.createElement('th');
      th.style.width = "100px";
      th.innerHTML = `<span class="item_label" style="pointer-events: none;"></span>`;

      var tbody = drag_el.querySelector("tbody");
      var tbody_tr = tbody.firstElementChild;
      var td = document.createElement('td');

      var tfoot = drag_el.querySelector("tfoot");

      var column = {
        dataType: "string", format: "",
        total: { dataType: "string", format: "" },
        intotal: { dataType: "string", format: "" }
      }

      if (type == "left") {
        thead_tr.insertBefore(th, thead_tr.cells[index]);
        tbody_tr.insertBefore(td, tbody_tr.cells[index]);
        drag_dom.columns.splice(index, 0, column);
        if (tfoot) {
          Array(...tfoot.children).forEach(tfoot_tr => {
            var tfoot_td = document.createElement('td');
            tfoot_tr.insertBefore(tfoot_td, tfoot_tr.cells[index]);
          })
        }
      } else {
        var islast = thead_tr.lastElementChild == thead_tr.cells[index];
        if (islast) thead_tr.appendChild(th);
        else thead_tr.insertBefore(th, thead_tr.cells[index + 1]);

        if (islast) tbody_tr.appendChild(td);
        else tbody_tr.insertBefore(td, tbody_tr.cells[index + 1]);

        if (drag_dom.columns.length == index) drag_dom.columns.push(column)
        else drag_dom.columns.splice((index + 1), 0, column);

        if (tfoot) {
          Array(...tfoot.children).forEach(tfoot_tr => {
            var tfoot_td = document.createElement('td');
            if (islast) tfoot_tr.appendChild(tfoot_td);
            else tfoot_tr.insertBefore(tfoot_td, tfoot_tr.cells[index + 1]);
          })
        }
      }
    },
    //删除表格列
    onDelCol() {
      this.isChange = true;
      // console.log("selectIndex", this.tableConfig.selectIndex);
      var drag_el = this.dragConfig.dragEl;
      // console.log("drag_el", drag_el);
      var thead = drag_el.querySelector("thead");
      var ths = thead.firstElementChild.cells;
      ths[this.tableConfig.selectIndex].remove();
      // console.log("ths", ths);

      var tbody = drag_el.querySelector("tbody");
      var tds = tbody.firstElementChild.cells;
      tds[this.tableConfig.selectIndex].remove();
      // console.log("tbody", tds);

      var tfoot = drag_el.querySelector("tfoot");
      if (tfoot) {
        Array(...tfoot.children).forEach(tfoot_tr => {
          tfoot_tr.cells[this.tableConfig.selectIndex].remove();
        })
      }
    },
    //元素操作相关函数
    onDblClick(e) {
      // console.log('onDblClick', e);

      var drag_el = this.dragConfig.dragEl;
      // console.log("双击鼠标", [drag_el]);

      var is_table = false;

      if (drag_el.className == "table-item") {
        if (e.target.localName == "th") {
          this.isChange = true;
          is_table = true;
          setTextarea(e.target);
        }
        if (e.target.localName == "td") {
          var total = e.target.parentNode.dataset.total;
          if (total && !e.target.dataset.field) {
            this.isChange = true;
            setInput(e.target);
          }
        }
      } else {
        if (drag_el.className == "img-item") {
          var btn = document.getElementById("img_upload");
          btn.click();
        } else {
          this.isChange = true;
          setTextarea(drag_el);
        }
      }

      function setTextarea(dom) {
        // console.log("dom", dom)
        var has = dom.getElementsByTagName("textarea");
        // console.log('has', has.length != 0);
        if (has.length != 0) return;

        // console.log("dom", dom);
        var label = dom.getElementsByClassName("item_label");
        if (label.length > 0) {
          label[0].style.display = "none";
          var textarea = document.createElement("textarea");
          textarea.style.width = "100%";
          textarea.style.height = "100%";
          textarea.style.border = "none";
          textarea.style.resize = "none";
          textarea.value = label[0].innerText;
          textarea.addEventListener("blur", function (e) {
            // console.log("label[0]", label[0]);
            // console.log('blur', e);
            label[0].innerText = e.target.value;
            textarea.remove();
            label[0].style.display = is_table ? "" : "flex";
          })
          dom.appendChild(textarea);
          textarea.focus();
        }
      }
      function setInput(dom) {
        var has = dom.querySelectorAll("input");
        // console.log('has', has.length);
        if (has.length != 0) return;

        var input = document.createElement("input");
        input.style.width = "100%";
        input.style.height = "100%";
        input.style.border = "none";
        input.style.resize = "none";
        input.value = dom.innerText;
        dom.innerText = "";
        input.addEventListener("blur", function (e) {
          dom.innerText = e.target.value;
          input.remove();
          // dom.style.display = is_table ? "" : "flex";
        })
        dom.appendChild(input);
        input.focus();
      }
    }
  }
};
</script>
<style lang="scss">
.test-box {
  max-height: 500px;
  position: fixed;
  right: 450px;
  overflow-y: scroll;
  background-color: white;
  z-index: 99;
  padding: 10px;
  box-shadow: 0px 0px 5px 5px #dedede;
}
.print-template {
  height: 100vh;
  .header {
    padding: 10px 20px;
    border-bottom: 1px solid #dedede;
    position: relative;
    .font-tools {
      width: 100%;
      display: flex;
      // pointer-events: none;
      // filter: opacity(0.5);
      .font-btn {
        position: relative;
        user-select: none;
        width: 28px;
        height: 28px;
        line-height: 28px;
        text-align: center;
        margin-left: 5px;

        border-radius: 3px;
        cursor: default;
        .icon {
          position: absolute;
          top: -3px;
          right: 3px;
        }
      }
      .font-btn:hover {
        background-color: #f1f1f1;
      }
    }
    .paper-tools,
    .table-tools {
      display: flex;
      height: 70px;
      .tools-item {
        display: flex;
        flex-direction: column;
        justify-content: space-around;
      }
    }
    .tools-disable {
      pointer-events: none;
      filter: opacity(0.5);
    }
  }
  .aside {
    margin: 0px;
    background: none;
    padding-left: 10px;
    padding-right: 10px;

    .tree-node {
      display: flex;
      width: 100%;
      justify-content: space-between;
      height: 26px;
      line-height: 26px;
      font-size: 14px;
      user-select: none;
    }
  }
  .right-aside {
    border-left: 1px solid #dedede;
  }
  .left-aside {
    border-right: 1px solid #dedede;
    .title {
      display: flex;
      justify-content: space-between;
      .btn-disable {
        pointer-events: none;
        filter: opacity(0.5);
      }
      i {
        cursor: pointer;
        margin-left: 5px;
      }
    }
    .item {
      font-size: 14px;
      line-height: 26px;
      cursor: pointer;
    }
    .item:hover {
      text-decoration: underline;
    }
    .item-active {
      background-color: #efefef;
    }
  }
  .main {
    position: relative;
    padding: 0;
    #printbox {
      margin: 20px;
      border: 1px solid #dedede;
      .paper {
        width: 100%;
        height: 100%;
        position: relative;
        font-size: 12px;

        .table-item {
          position: absolute;
          cursor: default;

          .row-number {
            width: 30px;
            height: 22px;
            line-height: 22px;
            text-align: right;
            font-size: 16px;
            position: absolute;
            top: 25px;
            left: -33px;
            color: #6a6a6a;
          }

          table {
            width: 100%;
            height: 100%;
            .active-th {
              background-color: #cfffd1;
            }
            .active-td {
              background-color: #cfe7ff;
            }
          }

          table,
          td,
          th {
            text-align: center;
            border: 1px solid #000;
            border-collapse: collapse;
          }

          table th {
            font-weight: unset;
          }

          // table td {
          //   padding: 10px 30px;
          // }
        }
      }
    }
    #contextmenu {
      position: absolute;
      // left: 50px;
      width: 100px;
      z-index: 999;
      background-color: white;
      border: 1px solid #dedede;
      box-shadow: 3px 3px 3px 1px #b9b9b9;
      .menu_item {
        // height: 30px;
        font-size: 14px;
        line-height: 30px;
        padding: 0 10px;
        cursor: pointer;
      }
      .menu_item:hover {
        color: white;
        background-color: #6d6d6d;
      }
      // .menu_item + .menu_item {
      //   border-top: 1px solid #dedede;
      // }
    }
    .equality_line {
      position: absolute;
      background-color: red;
      z-index: 99;
    }
    .zoom {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      pointer-events: none;
      .zoom-item {
        width: 5px;
        height: 5px;
        background: #409eff;
        // border: 1px solid gray;
        position: absolute;
        pointer-events: auto;
      }
      //上下 n-resize，左右 e-resize，右斜 ne-resize， 左斜 nw-resize
      .left-top {
        cursor: nw-resize; //西北
        left: 0;
        top: 0;
      }
      .top {
        cursor: n-resize; //北
        top: 0;
        left: 50%;
        transform: translateX(-50%);
      }
      .right-top {
        cursor: ne-resize; //东北
        top: 0;
        right: 0;
      }
      .left {
        cursor: w-resize; //西
        top: 50%;
        left: 0;
        transform: translateY(-50%);
      }
      .right {
        cursor: e-resize; //东
        top: 50%;
        right: 0;
        transform: translateY(-50%);
      }
      .left-bottom {
        cursor: sw-resize; //西南
        left: 0;
        bottom: 0;
      }
      .bottom {
        cursor: s-resize; //南
        left: 50%;
        bottom: 0;
        transform: translateX(-50%);
      }
      .right-bottom {
        cursor: se-resize; //东南
        right: 0;
        bottom: 0;
      }
    }
  }
}
</style>